function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { useAtom, useAtomValue } from "jotai";
import { devToolsOpenedAtom, devToolsSizeAtom } from "./state/global";
import DevToolsCollapsed from "./dev-tools-collapsed";
import DevToolsExpanded from "./dev-tools-expanded";
import { useResizeDocument } from "./hooks/use-resize-document";
import { useSubscribeToEditorView } from "./hooks/use-subscribe-to-editor-view";
import { useRollbackHistory } from "./hooks/use-rollback-history";
export default function DevTools(props) {
  var _useAtom = useAtom(devToolsOpenedAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    isOpen = _useAtom2[0],
    setIsOpen = _useAtom2[1];
  var defaultSize = useAtomValue(devToolsSizeAtom);
  var editorView = props.editorView;
  var toggleOpen = React.useCallback(function () {
    return setIsOpen(!isOpen);
  }, [isOpen]);
  useResizeDocument(isOpen, defaultSize);
  useSubscribeToEditorView(editorView, props.diffWorker);
  var rollbackHistory = useRollbackHistory(editorView);
  if (isOpen) {
    return /*#__PURE__*/React.createElement(DevToolsExpanded, {
      rollbackHistory: rollbackHistory
    });
  }
  return /*#__PURE__*/React.createElement(DevToolsCollapsed, {
    onClick: toggleOpen
  });
}